const wizardComponentsHelper = require('routes/contractsView/utilities/wizardComponenstHelper');
const inputs = require('routes/contractsView/fioc/inputs.js');

function buildRentier(prefix, authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    let grid = [];
    if (!authorized) {
        grid = [
            [[inputsFioc.incomes_annual]]
        ];
    }

    return {
        id_component: 'condition-show',
        id: 'show',
        conditionType: 'single',
        conditionId1: prefix + 'fioc_ocupation',
        conditionValue1: 2,
        item: {
            id_component: 'fioc',
            id: prefix + 'fioc_rentier',
            exclude: [],
            grid
        }
    }
}

module.exports = buildRentier;